import React from "react";

// Uma tabela de contadores. Serve tanto à quebra por cliente quanto à quebra por
// calculadora / tipo de consulta, porque as duas têm a mesma forma: um rótulo e
// quatro números.
//
// O rótulo chega pronto em `rows[].label` — a tradução (mapa de slug numa; nome
// do cliente ou linha órfã na outra) é do chamador. Este componente não conhece
// nem mapa de slug nem semântica de vínculo.
//
// Os contadores são de COBRANÇA, não de status HTTP: uma consulta que devolveu
// 404 ao cliente foi executada e paga (`success`); um cálculo que respondeu 200
// com { error } no corpo não foi cobrado (`error`). `unknown` é anterior à
// instrumentação (30/07/2026) e nunca é somado aos outros dois — daí a coluna
// própria, e daí os rótulos serem "Cobrável"/"Não cobrável" em vez de
// "Sucesso"/"Erro", que fariam o admin ler faturamento como taxa de falha.
export default function UsageTable({ rowLabel, rows, totals }) {
  return (
    <table className="table table-bordered table-sm table-striped">
      <thead>
        <tr>
          <th>{rowLabel}</th>
          <th>Total</th>
          <th>Cobrável</th>
          <th>Não cobrável</th>
          <th>Sem medição</th>
        </tr>
      </thead>
      <tbody>
        {totals && (
          <tr>
            <th>Total</th>
            <th>{totals.total}</th>
            <th>{totals.success}</th>
            <th>{totals.error}</th>
            <th>{totals.unknown}</th>
          </tr>
        )}
        {rows.map(row => (
          <tr key={row.key}>
            <td>{row.label}</td>
            <td>{row.total}</td>
            <td>{row.success}</td>
            <td>{row.error}</td>
            <td>{row.unknown}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
